import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import { BREAKPOINT_MD_SIZE, BREAKPOINT_SM_SIZE, BREAKPOINT_XS_SIZE } from '../tokens';

export type PageWidth = 'xs' | 'sm' | 'md' | 'lg';

export const getPageWidth = (width: number): PageWidth => {
  if (width <= BREAKPOINT_XS_SIZE) {
    return 'xs';
  }
  if (width <= BREAKPOINT_SM_SIZE) {
    return 'sm';
  }
  if (width <= BREAKPOINT_MD_SIZE) {
    return 'md';
  }
  return 'lg';
};

export const usePageWidth = (debounceDuration = 300): PageWidth | undefined => {
  const [pageWidth, setPageWidth] = useState<PageWidth>();

  const handleResize = useCallback(() => {
    if (typeof window !== 'undefined') {
      setPageWidth(getPageWidth(window.innerWidth));
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    setPageWidth(getPageWidth(window.innerWidth));
    const debounced = debounce(handleResize, debounceDuration);
    window.addEventListener('resize', debounced);
    return () => {
      window.removeEventListener('resize', debounced);
      debounced.cancel();
    };
  }, [debounceDuration, handleResize]);

  return pageWidth;
};
